// ABOUTME: UI component for displaying empty state when no SharePoint file is selected
// ABOUTME: Shows placeholder icon and message with consistent styling

import { Box, CloudOutlinedIcon, Typography } from '@ds/coolshop';
import React from 'react';
import { useIntl } from 'react-intl';

export const EmptyFileDisplay: React.FC = React.memo(() => {
    const intl = useIntl();

    return (
        <Box p={1} border={1} mb={1} textAlign="center" borderRadius={1} borderColor="grey.300">
            <CloudOutlinedIcon fontSize="large" />
            <Typography variant="body2" color="text.secondary">
                {intl.formatMessage({
                    id: 'sharepoint.no-file-selected',
                    defaultMessage: 'Nessun file SharePoint selezionato',
                })}
            </Typography>
        </Box>
    );
});

EmptyFileDisplay.displayName = 'EmptyFileDisplay';
